var chunkMapping = {
	"webpack_container_remote_mfe-error_Module": [
		41333
	],
	"webpack_container_remote_mfe-printer_Module": [
		35755
	],
	"webpack_container_remote_mfe-activity_Module": [
		99274
	],
	"webpack_container_remote_mfe-survey_Module": [
		96693
	],
	"webpack_container_remote_mfe-notifications_Module": [
		96475
	],
	"webpack_container_remote_mfe-catalogue_Module": [
		5190
	],
	"webpack_container_remote_mfe-enrolement_Module": [
		79284
	],
	"webpack_container_remote_mfe-calendar_Module": [
		32917
	],
	"webpack_container_remote_mfe-report_Module": [
		61353
	],
	"webpack_container_remote_mfe-evaluations_Module": [
		21752
	],
	"webpack_container_remote_mfe-profile_Module": [
		83914
	],
	"webpack_container_remote_mfe-help_Module": [
		97652
	],
	"webpack_container_remote_mfe-lexique_Module": [
		43086
	],
	"webpack_container_remote_mfe-passport_Module": [
		70765
	],
	"webpack_container_remote_mfe-faq_Module": [
		54199
	],
	"webpack_container_remote_mfe-document_Module": [
		51882
	],
	"webpack_container_remote_mfe-dashbord-admin_Module": [
		15056
	],
	"webpack_container_remote_mfe-tags_Module": [
		64614
	],
	"webpack_container_remote_mfe-users_Module": [
		26695
	],
	"webpack_container_remote_mfe-folder_Module": [
		50847
	],
	"webpack_container_remote_mfe-massist_Module": [
		77787
	],
	"webpack_container_remote_mfesignup_Module": [
		52758
	],
	"webpack_container_remote_mfe-forgot_Module": [
		18555
	],
	"webpack_container_remote_mfegroups_Module": [
		71294
	],
	"webpack_container_remote_mfe-inscription_Module": [
		42909
	],
	"webpack_container_remote_mfe-visibility_Module": [
		30943
	],
	"webpack_container_remote_mfe-statistics_Module": [
		79892
	]
};
var idToExternalAndNameMapping = {
	"5190": [
		"default",
		"./Module",
		12975
	],
	"15056": [
		"default",
		"./Module",
		48527
	],
	"18555": [
		"default",
		"./Module",
		28023
	],
	"21752": [
		"default",
		"./Module",
		35457
	],
	"26695": [
		"default",
		"./Module",
		70982
	],
	"30943": [
		"default",
		"./Module",
		25607
	],
	"32917": [
		"default",
		"./Module",
		58546
	],
	"35755": [
		"default",
		"./Module",
		3330
	],
	"41333": [
		"default",
		"./Module",
		78824
	],
	"42909": [
		"default",
		"./Module",
		16180
	],
	"43086": [
		"default",
		"./Module",
		42931
	],
	"50847": [
		"default",
		"./Module",
		85676
	],
	"51882": [
		"default",
		"./Module",
		5529
	],
	"52758": [
		"default",
		"./Module",
		84435
	],
	"54199": [
		"default",
		"./Module",
		45542
	],
	"61353": [
		"default",
		"./Module",
		79438
	],
	"64614": [
		"default",
		"./Module",
		58517
	],
	"70765": [
		"default",
		"./Module",
		71678
	],
	"71294": [
		"default",
		"./Module",
		46667
	],
	"77787": [
		"default",
		"./Module",
		49674
	],
	"79284": [
		"default",
		"./Module",
		74955
	],
	"79892": [
		"default",
		"./Module",
		31179
	],
	"83914": [
		"default",
		"./Module",
		7220
	],
	"96475": [
		"default",
		"./Module",
		2018
	],
	"96693": [
		"default",
		"./Module",
		52514
	],
	"97652": [
		"default",
		"./Module",
		78307
	],
	"99274": [
		"default",
		"./Module",
		7265
	]
};
var idToRemoteMap = {
	"5190": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 12975
		}
	],
	"15056": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 48527
		}
	],
	"18555": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 28023
		}
	],
	"21752": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 35457
		}
	],
	"26695": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 70982
		}
	],
	"30943": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 25607
		}
	],
	"32917": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 58546
		}
	],
	"35755": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 3330
		}
	],
	"41333": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 78824
		}
	],
	"42909": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 16180
		}
	],
	"43086": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 42931
		}
	],
	"50847": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 85676
		}
	],
	"51882": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 5529
		}
	],
	"52758": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 84435
		}
	],
	"54199": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 45542
		}
	],
	"61353": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 79438
		}
	],
	"64614": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 58517
		}
	],
	"70765": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 71678
		}
	],
	"71294": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 46667
		}
	],
	"77787": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 49674
		}
	],
	"79284": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 74955
		}
	],
	"79892": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 31179
		}
	],
	"83914": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 7220
		}
	],
	"96475": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 2018
		}
	],
	"96693": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 52514
		}
	],
	"97652": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 78307
		}
	],
	"99274": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 7265
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}